export default __webpack_public_path__ + "navigation-examples-waypoint-arrival-screen-960-4bf511572b7c50b48f069cfdf860222f.png";